import { render, staticRenderFns } from "./lungcancerFollowupForm.vue?vue&type=template&id=bf037614&scoped=true"
import script from "./lungcancerFollowupForm.vue?vue&type=script&lang=js"
export * from "./lungcancerFollowupForm.vue?vue&type=script&lang=js"
import style0 from "./lungcancerFollowupForm.vue?vue&type=style&index=0&id=bf037614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf037614",
  null
  
)

export default component.exports